import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'SettingsModalContainer'

    static propTypes = {
      advisorOptions: PropTypes.array.isRequired,
      close: PropTypes.func.isRequired,
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      setAdditionalAdvisors: PropTypes.func.isRequired,
      setSetting: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    handleAdditionalAdvisors = (e, { value }) => {
      const { setAdditionalAdvisors, user } = this.props

      setAdditionalAdvisors(value, user.id)
    }

    handleCheckbox = (e, { checked, name }) => {
      const { setSetting, user } = this.props

      setSetting(name, checked ? 'true' : 'false', user)
    }

    handleChoice = (e, { name, value }) => {
      const { setSetting, user } = this.props

      setSetting(name, value, user)
    }

    render() {
      return (
        <WrappedComponent
          advisorOptions={this.props.advisorOptions}
          close={this.props.close}
          handleAdditionalAdvisors={this.handleAdditionalAdvisors}
          handleCheckbox={this.handleCheckbox}
          handleChoice={this.handleChoice}
          hasError={this.props.hasError}
          isPending={this.props.isPending}
          setAdditionalAdvisors={this.props.setAdditionalAdvisors}
          setSetting={this.props.setSetting}
          user={this.props.user}
        />
      )
    }
  }

  return Container
}
